import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA, MatInputModule } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { DialogData } from '../../model/data.model';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import lifeQuoteJson from '../../life-config/lifeQuotesConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import lifeProductType from '../../life-config/productCodeConfig.json';

@Component({
  selector: 'app-annual-income-modal',
  templateUrl: './annual-income-modal.component.html',
  styleUrls: ['./annual-income-modal.component.css']
})

export class AnnualIncomeModalComponent implements OnInit {

  uuid: string;
  proposalId: string;
  editQuoteModalJson: any = lifeQuoteJson.editModalInitialJson;
  productType: object = lifeProductType.componentClassName;
  apiUrl: object = apiUrlPoint.apiEndPoints;
  annualIncomeInfo: FormGroup;
  annualIncomeData: any;
  editQuoteResponse: any;
  destroySubject$: Subject<void> = new Subject();

  constructor(
    private dialogRef: MatDialogRef<AnnualIncomeModalComponent>,
    private formbuild: FormBuilder,
    private apiService: ApiService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {

    this.annualIncomeInfo = this.formbuild.group({

        annualIncome: ['', [Validators.required, Validators.pattern(new RegExp('^[0-9,]*$'))]]
    });

    /**
     * Preventing model on esc and mouse click
     */

    dialogRef.disableClose = true;

    this.uuid = data['uuid'],
    this.proposalId = data['proposalId'];

   }

   saveAnnualModalData( isvalid: boolean, event) {

    if (isvalid) {

        /**
         * This code is reusing again and agin
         * Add it from utils
         *
         */
        const annualIncomeTemp = this.annualIncomeInfo.get('annualIncome').value;
        if (typeof annualIncomeTemp !== 'number' && (annualIncomeTemp).indexOf(',') > -1) {
                this.annualIncomeData = (this.annualIncomeInfo.get('annualIncome').value).replace(/,\s?/g, '');
        } else {
                this.annualIncomeData = this.annualIncomeInfo.get('annualIncome').value;
        }

        const data = {


            lifeassured: {

                annual_income: this.annualIncomeData
            }

        };

        this.apiService.updateProposal(
            this.apiUrl['apiV2LifeProposal'],
            this.proposalId,  this.uuid,
            this.apiUrl['update_proposal'], data).subscribe(res => {

            this.editQuoteResponse = res['response'];
            if (this.editQuoteResponse) {
                // if (this.activatedRoute.component['name'] === this.productType['biComponenthandlerClass']) {
                //     const resObtainedFromEditModal = this.sharedData.getRecalculatedPremium();
                //     this.dialogRef.close({ event: 'close', data: resObtainedFromEditModal });
                // }


              this.initiateQuote();
                // tslint:disable-next-line: max-line-length
              this.dialogRef.close({ event: 'close', data: this.editQuoteResponse });



            }

        }, err => {
            this.dialogRef.disableClose = true;
        });

    }

   }


   /**
    * this is being iterated
    * Since annual income field will be removed , so using this
    */

   initiateQuote() {

    // tslint:disable-next-line: max-line-length
    this.apiService.postIntiateQuote(this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['initiate_quotations'], this.apiUrl['extraParams'])

        .pipe(takeUntil(this.destroySubject$))

        .subscribe(res => {
            const iniateQuoteInfo = res;




        });
}

  ngOnInit() {
  }

}
